import script from "./LocMetadataForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./LocMetadataForm.vue?vue&type=script&setup=true&lang=ts"

import "@/assets/css/loans/form.css?vue&type=style&index=0&id=39b2d4c8&scoped=true&lang=css&external"
import "./LocMetadataForm.vue?vue&type=style&index=1&id=39b2d4c8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-39b2d4c8"]])

export default __exports__